// import React from 'react';
// import { useMsal, useIsAuthenticated } from "@azure/msal-react";
// import { Navigate } from "react-router-dom";
// import { loginRequest } from "../../config/msalConfig";

// // Function to handle the login process
// function handleLogin(instance: any) {
//     instance.loginRedirect(loginRequest).catch((e: any) => {
//         console.error(e);
//     });
// }

// const Login = () => {
//     const { instance } = useMsal();
//     // This hook checks MSAL's authentication status
//     const isAuthenticated = useIsAuthenticated(); 

//     if (isAuthenticated) {
//         // If the user is authenticated, redirect to the home page
//         return <Navigate to="/" />;
//     }

//     // If not authenticated, show the login button
//     return (
//         <div>
//             <h2>Please sign in</h2>
//             <button onClick={() => handleLogin(instance)}>
//                 Sign in with Microsoft
//             </button>
//         </div>
//     );
// };

// export default Login;


import React, { CSSProperties } from 'react'; // Import CSSProperties for better type safety
import { useMsal, useIsAuthenticated } from "@azure/msal-react";
import { Navigate } from "react-router-dom";
import { loginRequest } from "../../config/msalConfig";

// Function to handle the login process
function handleLogin(instance: any) {
    instance.loginRedirect(loginRequest).catch((e: any) => {
        console.error(e);
    });
}

// 1. Define Inline Styles
const containerStyle: CSSProperties = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '100vh',
    fontFamily: 'Arial, sans-serif',
    backgroundColor: '#f4f7f6', // Light background for the whole page
};

const cardStyle: CSSProperties = {
    padding: '40px',
    borderRadius: '10px',
    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
    backgroundColor: '#ffffff', // White card background
    textAlign: 'center',
    maxWidth: '400px',
    width: '90%',
};

const headingStyle: CSSProperties = {
    color: '#333333',
    marginBottom: '20px',
    fontSize: '1.8rem',
    fontWeight: '600',
};

const buttonStyle: CSSProperties = {
    padding: '12px 25px',
    fontSize: '1rem',
    cursor: 'pointer',
    borderRadius: '5px',
    border: 'none',
    backgroundColor: '#0078D4', // Standard Microsoft blue
    color: 'white',
    fontWeight: 'bold',
    transition: 'background-color 0.3s ease',
    // We can't use :hover in inline styles, but this gives a good look
};

// NOTE: You can't define hover effects with pure inline styles. 
// For a better user experience, consider moving to a CSS module or styled-components later.

const Login = () => {
    const { instance } = useMsal();
    const isAuthenticated = useIsAuthenticated(); 

    if (isAuthenticated) {
        return <Navigate to="/" />;
    }

    // If not authenticated, show the login button
    return (
        <div style={containerStyle}>
            <div style={cardStyle}>
                <h2 style={headingStyle}>Please sign in</h2>
                <button 
                    onClick={() => handleLogin(instance)}
                    style={buttonStyle}
                >
                    Sign in with Microsoft
                </button>
            </div>
        </div>
    );
};

export default Login;